import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { ToasterService } from '../../../shared/services/toaster/toaster.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {

  public user_email: string = '';
  public form_submitted: boolean = false;
  public loading: boolean = false;
  public successMessage: string | null = null; // To store the success message

  constructor(
    private Auth_Service: AuthService,
    private Toaster: ToasterService,
    private Router: Router,
  ) { }

  public async reset() {
    this.form_submitted = true;
    this.loading = true;
    try {
      // Guard against missing credentials
      if (!this.user_email) throw `Missing email`;
      // Call the initiatePasswordReset method
      const success = await this.Auth_Service.initiatePasswordReset(this.user_email);
      if (success) {
        this.successMessage = '🎉 Password reset link has been sent! Please check your email for the next step';
      } else {
        this.Toaster.warning('Failed to send password reset link. Please try again.');
      }
    } catch (error) {
      this.Toaster.warning(`Password reset error: ${error}`);
    } finally {
      this.loading = false;
    }
  }

  public isEmailValid(): boolean {
    const emailRegex = /^\S+@\S+\.\S+$/;
    return emailRegex.test(this.user_email);
  }

  ngOnInit(): void {
  }

}